// removed by extract-text-webpack-plugin
module.exports = {"icon":"icon--2ugJy"};


/*****************
 ** WEBPACK FOOTER
 ** ./shared-components/SearchBar/components/magnifyingGlass.scss
 ** module id = 615
 ** module chunks = 2 17
 **/